import { proxy } from 'valtio';
import { CepConfigurationStepStateType } from 'basics/types/maya.types';

const cepConfigurationStepState = proxy<CepConfigurationStepStateType>({
  isOpenConfirmationModal: false,
});

export default cepConfigurationStepState;
